import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Arrow from "../../assets/images/link-arrow.png";

import "./news.scss";
import parse from "html-react-parser";
export const News = ({ blog }) => {
    // useEffect(() => {
    //   // setBlogId(data.id);
    // });
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(`/main-news/${blog.slug}`);
    };

    return (
        <div onClick={handleClick} className="news-component col-md-6 flexy flexyM">
            <div
                className="col-md-6 col-6 news-img"
            >
                <img src={blog.thumbnail} width="100%" />
            </div>
            <div className="col-md-6 col-6 news-details">
                <h6>{blog.title}</h6>
                <small>{blog.date}</small>

                <p>{parse(blog.content)}</p>
                <Link
                    className="news-link"
                    to={`/main-news/${blog.slug}`}
                >
                    Read More <img src={Arrow} width="17px" />
                </Link>
            </div>
        </div>
    );
};
